"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavigationAction;
(function (NavigationAction) {
    NavigationAction[NavigationAction["Previous"] = -1] = "Previous";
    NavigationAction[NavigationAction["Next"] = 1] = "Next";
})(NavigationAction = exports.NavigationAction || (exports.NavigationAction = {}));
//# sourceMappingURL=types.js.map